﻿export class SectionTypes {

    static STATEMENT = "statement";
    static BUTTON_OPTIONS = "buttonOptions";
    static SITE = "site";
    static LIKERT = "likert";
    static RATING = "rating";
    static LONG_TEXT = "longText"

}